import React from 'react';
import { useSelector } from 'react-redux';

import Table from 'components/Table';

import {
  getTableData,
  getConfidenceInterval
} from 'store/scenes/inferentialStatistics/selectors';

const TConfidenceInterval = () => {
  const tableData = useSelector(state => getTableData(state));
  const confidenceInterval = useSelector(state => getConfidenceInterval(state));
  const tableHeaders = ['n', 'Mean', 'Standard Deviation', 'Standard Error', 'df', 'Lower Limit', 'Upper Limit'];

  return (
    <div className="content-item">
      <h3>One Sample <i>t</i> Confidence Interval Summary</h3>
      <span className="font-900 font-16 mb-10">μ: mean of population</span>
      <div>
        <span className="mr-5">{confidenceInterval}%</span><span className="font-900 font-16 mb-10">Confidence Interval for μ</span>
      </div>
      <br />
      <Table
        tableHeaders={tableHeaders}
        tableData={tableData}
      />
    </div>
  );
};

export default TConfidenceInterval;
